import React from 'react';
import styled from 'styled-components';
import { Label } from 'components/Typography';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import {
  Container,
  Optional,
  CheckIcon,
  StyledTooltip,
  Comment
} from '../TextInput/styled';
import { CheckBox, ErrorMessage, NewInputStyle } from './styled';

const CheckboxInput = ({
  label = '',
  comment = '',
  tooltip = '',
  optional = false,
  size = 'medium',
  name,
  disabled,
  className,
  formik
}) => {
  const handleChange = (e) => {
    // Update Formik's state to reflect checkbox's checked state
    const { checked } = e.target;
    formik?.setFieldValue(name, checked);
  };

  const renderLabel = (
    <Label htmlFor={name} size={size}>
      {label}
      {tooltip && <StyledTooltip>{tooltip}</StyledTooltip>}
      {optional && <Optional>- optional</Optional>}
      {formik && (
        <>
          {formik.touched[name] && formik.errors[name] ? (
            // @ts-ignore
            <ErrorMessage>{formik.errors[name]}</ErrorMessage>
          ) : null}
          {!formik.errors[name] && formik.touched[name] && formik.dirty && <CheckIcon />}
        </>
      )}
      {comment && <Comment>{comment}</Comment>}
    </Label>
  );

  return (
    <Container size={size} className={className}>
      {label && renderLabel}
      <CheckBox
        id={name}
        name={name}
        type="checkbox"
        disabled={disabled}
        checked={get(formik, `values.${name}`)}
        onChange={handleChange}
      />
    </Container>
  );
};

CheckboxInput.propTypes = {
  formik: PropTypes.object, // Replace 'object' with a more specific shape if needed
  name: PropTypes.string.isRequired,
  optional: PropTypes.bool,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node // For React nodes
  ]),
  comment: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node // For React nodes
  ]),
  tooltip: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['medium', 'large', 'extralarge'])
};

export const NewCheckboxInput = styled(CheckboxInput)`
  ${NewInputStyle}
`;

export default CheckboxInput;
